import { render } from "./MyMentorsPage.vue?vue&type=template&id=86956fd8"
import script from "./MyMentorsPage.vue?vue&type=script&lang=js"
export * from "./MyMentorsPage.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__